import React from 'react';

import theme from '../../../common/util/theme';

export const AudioLoadingBar = (): JSX.Element => (
  <svg viewBox="0 0 1001 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="61px">
    <rect x="0" y="0" width="1001" height="60" fill={theme.colors.gray[100]} />
  </svg>
);
